module.exports = __webpack_public_path__ + "static/media/wood-top.c1250d92.png";